import { useEffect, useState } from 'react';
import { getFeatureFlags } from '../config/features';

export function useFeatureFlags() {
  const [flags, setFlags] = useState(() => getFeatureFlags());

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const updateFlags = () => {
      setFlags(getFeatureFlags());
    };

    updateFlags();

    mediaQuery.addEventListener?.('change', updateFlags);
    window.addEventListener('resize', updateFlags, { passive: true });

    return () => {
      mediaQuery.removeEventListener?.('change', updateFlags);
      window.removeEventListener('resize', updateFlags);
    };
  }, []);

  return flags;
}
